import { Organizations } from './Organizations';


export function TSBOrganizations() {
  return <Organizations
    title='TeamSnap for Business Organizations'
    isOrgV2={false}
  />
};